module.exports = __webpack_public_path__ + "static/media/facebook.65130b5e.svg";